/* eslint-disable object-curly-newline */
import {
  isRequired,
  validateEmailFormat,
  Validator,
} from '../../common/hooks/useFormControls';

export const requiredField = Validator(isRequired, 'THIS FIELD IS REQUIRED.');
export const validEmail = Validator(validateEmailFormat, 'ENTER A VALID EMAIL.');

const trimWhitespace = (value) => value.trim();

export const pressReleaseCreateFields = [
  { fieldName: 'title', value: '', validators: [requiredField], sanitizers: [trimWhitespace] },
  { fieldName: 'subheader', value: '', validators: [], sanitizers: [trimWhitespace] },
  { fieldName: 'full_text', value: '', validators: [requiredField], sanitizers: [trimWhitespace] },
  { fieldName: 'company_description', value: '', validators: [requiredField], sanitizers: [trimWhitespace] },
  { fieldName: 'company_name', value: '', validators: [requiredField], sanitizers: [trimWhitespace] },
  { fieldName: 'company_url', value: '', validators: [], sanitizers: [trimWhitespace] },
  { fieldName: 'company_city', value: '', validators: [requiredField], sanitizers: [trimWhitespace] },
  { fieldName: 'company_country', value: '', validators: [requiredField] },
  { fieldName: 'company_state_territory', value: '', validators: [] },
  { fieldName: 'cloudinary_company_logo', value: '', validators: [], sanitizers: [trimWhitespace] },
  { fieldName: 'cloudinary_header_image', value: '', validators: [], sanitizers: [trimWhitespace] },
  { fieldName: 'publish_date', value: null, validators: [] },
  { fieldName: 'accept_content_policy', value: false, validators: [requiredField] },
];

export const pressReleaseContactFields = [
  { fieldName: 'submitter_name', value: '', validators: [requiredField], sanitizers: [trimWhitespace] },
  { fieldName: 'submitter_email', value: '', validators: [requiredField, validEmail], sanitizers: [trimWhitespace] },
  { fieldName: 'submitter_company', value: '', validators: [requiredField], sanitizers: [trimWhitespace] },
  { fieldName: 'submitter_title', value: '', validators: [], sanitizers: [trimWhitespace] },
];

export const pressContactFields = [
  { fieldName: 'name', value: '', validators: [], sanitizers: [trimWhitespace] },
  { fieldName: 'email', value: '', validators: [validEmail], sanitizers: [trimWhitespace] },
  { fieldName: 'phone_number', value: '', validators: [], sanitizers: [trimWhitespace] },
];

export const paymentFields = [
  { fieldName: 'billingContactName', value: '' },
  { fieldName: 'billingContactEmail', value: '' },
];

export const pressReleaseFormFields = [...pressReleaseCreateFields, ...pressReleaseContactFields];
